const units = ['байт', 'KB', 'MB', 'GB'];

export default function (fileSize){
  let l = 0, currentFileSize = parseInt(fileSize, 10) || 0;
  while(currentFileSize >= 1000 && ++l){
    currentFileSize = currentFileSize/1000;
  }
  return(currentFileSize.toFixed(currentFileSize < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
}